import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import NoteCard from "@/components/app/NoteCard";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * Featured rail — homepage-only. Shows up to 20 active featured notes ordered
 * by position (1 = most recent purchase). Each card includes a live countdown
 * of days remaining. Automatically empty when nothing is featured.
 */
export default function FeaturedRail({ onOffer }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/marketplace/featured")
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16" data-testid="featured-rail">
      <div className="flex items-end justify-between mb-8 border-b border-border pb-4">
        <div>
          <div className="flex items-center gap-2 font-overline text-accent">
            <Sparkles className="w-4 h-4" /> Featured Listings
          </div>
          <h2 className="font-display text-3xl sm:text-4xl mt-2">Spotlighted Notes</h2>
          <p className="text-muted-foreground mt-1">Sellers who paid to promote their listings to the top of the marketplace.</p>
        </div>
        <Link to="/notes" className="hidden sm:flex items-center gap-2 text-sm font-overline hover:text-primary">
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-testid="featured-grid">
        {items.map((rec) => (
          <div key={rec.featured_id} className="relative" data-testid={`featured-slot-${rec.position}`}>
            <div className="absolute top-2 left-2 z-10 px-2 py-0.5 text-[10px] font-mono-data uppercase tracking-wider bg-amber-400 text-zinc-900 flex items-center gap-1">
              <Sparkles className="w-3 h-3" /> Featured · #{rec.position}
            </div>
            <div className="absolute top-2 right-2 z-10 px-2 py-0.5 text-[10px] font-mono-data uppercase tracking-wider bg-zinc-900/85 text-white" data-testid={`featured-countdown-${rec.featured_id}`}>
              {rec.days_remaining}d left
            </div>
            <NoteCard note={rec.note} onMakeOffer={onOffer} />
          </div>
        ))}
      </div>
    </section>
  );
}
